import { Position } from 'src/common-services'
import {
  AddressShapeResponse,
  PropertiesCitiesShapesResponse,
  PropertiesNeighborhoodsShapesResponse,
  PropertiesZipCodesShapesResponse,
  PropertyIntrospectionResponse,
  PropertyRecordsRequest,
  PropertyRecordsResponse,
  ShapesRequest,
} from 'src/common-services/types/properties-types'
import { BaseClient } from 'src/common-services/clients/base-client'

export class PropertiesClient extends BaseClient {
  getAddressShape(address: string): Promise<AddressShapeResponse> {
    return this.call('/vendors/properties/address-shapes', 'GET', { params: { address } })
  }

  getPropertyRecords(request: PropertyRecordsRequest): Promise<PropertyRecordsResponse> {
    return this.call<PropertyRecordsResponse>('/vendors/properties/property-records', 'GET', {
      params: request,
    })
  }

  getNormalizedAddressByAddress(address: string) {
    const params = new URLSearchParams({ address })
    return this.call<string>(`/vendors/properties/normalized-address/by-address?${params}`, 'GET')
  }

  getNormalizedAddress(point: Position) {
    const [lng, lat] = point
    const params = new URLSearchParams({ lat: lat.toString(), lng: lng.toString() })
    return this.call<string>(`/vendors/properties/normalized-address?${params}`, 'GET')
  }

  getZipCodes(request: ShapesRequest): Promise<PropertiesZipCodesShapesResponse> {
    return this.call<PropertiesZipCodesShapesResponse>('/vendors/properties/borders/zip-codes', 'POST', {
      data: request,
    })
  }

  getNeighborhoods(request: ShapesRequest): Promise<PropertiesNeighborhoodsShapesResponse> {
    return this.call<PropertiesNeighborhoodsShapesResponse>('/vendors/properties/borders/neighborhoods', 'POST', {
      data: request,
    })
  }

  getCities(request: ShapesRequest): Promise<PropertiesCitiesShapesResponse> {
    return this.call<PropertiesCitiesShapesResponse>('/vendors/properties/borders/cities', 'POST', { data: request })
  }

  getZipCodesByH3R5Id(h3R5Id: string): Promise<PropertiesZipCodesShapesResponse> {
    const params = new URLSearchParams({
      h3R5Id,
    })
    return this.call<PropertiesZipCodesShapesResponse>(`/vendors/properties/borders/zip-codes-by-h3?${params}`, 'GET')
  }

  introspect(address: string) {
    const params = new URLSearchParams({ address })
    return this.call<PropertyIntrospectionResponse>(`/vendors/properties/introspect?${params}`, 'GET')
  }
}
